import { HttpMethod } from '../../http/HttpRequest';
import { combineURLs } from '../../utils/URL';
/**
 * @hidden
 */
export class OAuth2Client {
    constructor(clientCredentials, { authUrl = 'https://auth.adis.ws' }, httpClient) {
        this.authUrl = authUrl;
        this.clientCredentials = clientCredentials;
        this.httpClient = httpClient;
    }
    /**
     * Requests an authentication token that can be used
     * to make requests to the Dynamic Content api.
     * Tokens are reused until they expire.
     *
     * @returns {Promise<AccessToken>}
     */
    async getToken() {
        if (this.inFlight != null) {
            return this.inFlight;
        }
        if (this.token != null && this.tokenExpires > Date.now()) {
            return this.token;
        }
        const payload = 'grant_type=client_credentials' +
            '&client_id=' +
            encodeURIComponent(this.clientCredentials.client_id) +
            '&client_secret=' +
            encodeURIComponent(this.clientCredentials.client_secret);
        const request = this.httpClient.request({
            data: payload,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            method: HttpMethod.POST,
            url: combineURLs(this.authUrl, '/oauth/token'),
        });
        this.inFlight = request.then((response) => {
            if (typeof response.data !== 'object') {
                throw new Error('Unexpected response format from /oauth/token endpoint');
            }
            this.token = response.data;
            this.tokenExpires = Date.now() + this.token.expires_in * 1000;
            this.inFlight = null;
            return this.token;
        });
        return this.inFlight;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT0F1dGgyQ2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9vYXV0aDIvc2VydmljZXMvT0F1dGgyQ2xpZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSx3QkFBd0IsQ0FBQztBQUNwRCxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFLOUM7O0dBRUc7QUFDSCxNQUFNLE9BQU8sWUFBWTtJQVN2QixZQUNFLGlCQUEwQyxFQUMxQyxFQUFFLE9BQU8sR0FBRyxzQkFBc0IsRUFBRSxFQUNwQyxVQUFzQjtRQUV0QixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUN2QixJQUFJLENBQUMsaUJBQWlCLEdBQUcsaUJBQWlCLENBQUM7UUFDM0MsSUFBSSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUM7SUFDL0IsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLEtBQUssQ0FBQyxRQUFRO1FBQ25CLElBQUksSUFBSSxDQUFDLFFBQVEsSUFBSSxJQUFJLEVBQUU7WUFDekIsT0FBTyxJQUFJLENBQUMsUUFBUSxDQUFDO1NBQ3RCO1FBRUQsSUFBSSxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksSUFBSSxJQUFJLENBQUMsWUFBWSxHQUFHLElBQUksQ0FBQyxHQUFHLEVBQUUsRUFBRTtZQUN4RCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7U0FDbkI7UUFFRCxNQUFNLE9BQU8sR0FDWCwrQkFBK0I7WUFDL0IsYUFBYTtZQUNiLGtCQUFrQixDQUFDLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxTQUFTLENBQUM7WUFDcEQsaUJBQWlCO1lBQ2pCLGtCQUFrQixDQUFDLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxhQUFhLENBQUMsQ0FBQztRQUUzRCxNQUFNLE9BQU8sR0FBRyxJQUFJLENBQUMsVUFBVSxDQUFDLE9BQU8sQ0FBQztZQUN0QyxJQUFJLEVBQUUsT0FBTztZQUNiLE9BQU8sRUFBRTtnQkFDUCxjQUFjLEVBQUUsbUNBQW1DO2FBQ3BEO1lBQ0QsTUFBTSxFQUFFLFVBQVUsQ0FBQyxJQUFJO1lBQ3ZCLEdBQUcsRUFBRSxXQUFXLENBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxjQUFjLENBQUM7U0FDL0MsQ0FBQyxDQUFDO1FBRUgsSUFBSSxDQUFDLFFBQVEsR0FBRyxPQUFPLENBQUMsSUFBSSxDQUMxQixDQUFDLFFBQVEsRUFBZSxFQUFFO1lBQ3hCLElBQUksT0FBTyxRQUFRLENBQUMsSUFBSSxLQUFLLFFBQVEsRUFBRTtnQkFDckMsTUFBTSxJQUFJLEtBQUssQ0FDYix1REFBdUQsQ0FDeEQsQ0FBQzthQUNIO1lBRUQsSUFBSSxDQUFDLEtBQUssR0FBRyxRQUFRLENBQUMsSUFBVyxDQUFDO1lBQ2xDLElBQUksQ0FBQyxZQUFZLEdBQUcsSUFBSSxDQUFDLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQztZQUM5RCxJQUFJLENBQUMsUUFBUSxHQUFHLElBQUksQ0FBQztZQUNyQixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7UUFDcEIsQ0FBQyxDQUNzQixDQUFDO1FBRTFCLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQztJQUN2QixDQUFDO0NBQ0YifQ==